document.addEventListener('wpcf7mailsent', function (event) {
    // Run only for one specific CF7 form ID:
    if (event.detail.contactFormId !== 778322401) return;

    const form = event.target;

    // Prevent infinite loop if something re-triggers
    if (form.dataset.externalSubmitted === '1') return;
    form.dataset.externalSubmitted = '1';

    // Point the form to your external endpoint and submit normally (POST)
    form.action = 'https://www.ifirma.pl/app/wa/register';
    form.method = 'post';

    form.submit();
}, false);
